<div class="wizard-navigation">
  <!-- Steps indicator - Horizontal numbered steps like in mockup -->
  <div class="steps-container">
    <div class="steps-list">
      @for (step of steps(); track step.id; let i = $index) {
        <div
          class="step-item"
          [class]="getStepStyleClass(step, i)"
          [title]="getStepTooltip(step, i)"
          (click)="step.isSkipped ? null : onStepClick(i)"
        >
          <div class="step-circle">
            @if (step.isSkipped) {
              <span class="step-icon"><i class="pi pi-times"></i></span>
            } @else if (step.isCompleted && !step.isValid) {
              <span class="step-icon"
                ><i [class]="getStepIcon(step, i)"></i
              ></span>
            } @else if (step.isCompleted && step.isValid) {
              <span class="step-icon"
                ><i [class]="getStepIcon(step, i)"></i
              ></span>
            } @else if (i === currentStepIndex()) {
              <span class="step-number">{{ i + 1 }}</span>
            } @else if (!canNavigateToStep(i) && i > currentStepIndex()) {
              <span class="step-icon"
                ><i [class]="getStepIcon(step, i)"></i
              ></span>
            } @else {
              <span class="step-number">{{ i + 1 }}</span>
            }
          </div>
          @if (!resizeService.isMobile()) {
            <div class="step-label">
              {{ step.title }}
            </div>
          }
          @if (step.isCompleted && !step.isValid) {
            <div class="step-error-indicator">
              <i class="pi pi-exclamation-circle text-red-500 text-xs"></i>
            </div>
          }
        </div>

        @if (i < steps().length - 1) {
          <div
            class="step-connector"
            [style]="
              steps().length > 4 && resizeService.isMobile()
                ? { margin: '0', 'min-width': '4px' }
                : null
            "
            [class.completed]="
              currentStepIndex() > i &&
              ((step.isCompleted && step.isValid) || step.isSkipped)
            "
            [class.error]="step.isCompleted && !step.isValid"
            [class.skipped]="step.isSkipped && currentStepIndex() > i"
          ></div>
        }
      }
    </div>
  </div>

  <!-- contenuto stepper -->
  <ng-content #steppers />

  <!-- Navigation buttons - Bottom fixed like in mockup -->
  @if (!wizardStore.hideNavigationButton()) {
    <div class="navigation-buttons">
      <div class="navigation-container">
        <!-- Back button -->
        <div class="w-32 lg:w-48">
          <p-button
            [disabled]="!canGoBack()"
            [label]="'shared_back' | translate"
            severity="primary"
            variant="outlined"
            class="w-full"
            (click)="onPrevious()"
          />
        </div>

        <div class="flex gap-3">
          <!-- Cancel button -->
          <div class="w-24 lg:w-48 mr-4">
            <button
              (click)="onCancel()"
              pButton
              severity="secondary"
              class="w-full"
            >
              {{ "WIZARD.NAVIGATION.CANCEL" | translate }}
            </button>
          </div>

          <!-- Next/Save button -->
          @if (isLastStep()) {
            <div class="w-36 lg:w-48">
              <button
                pButton
                routerLink="nuovo-cliente"
                type="button"
                class="btn-generic font-medium"
                [disabled]="!canCompleteWizard()"
                [title]="
                  canCompleteWizard()
                    ? ('WIZARD.NAVIGATION.SAVE_TOOLTIP' | translate)
                    : ('WIZARD.NAVIGATION.SAVE_TOOLTIP_DISABLED' | translate)
                "
                (click)="onSave()"
              >
                {{ saveButtonText() | translate }}
              </button>
            </div>
          } @else {
            <div class="w-32 lg:w-48">
              <button
                pButton
                routerLink="nuovo-cliente"
                [disabled]="disabledNextMobileWithoutFirma()"
                type="button"
                class="btn-generic font-medium"
                [title]="
                  canGoNext()
                    ? ('WIZARD.NAVIGATION.NEXT_TOOLTIP' | translate)
                    : ('WIZARD.NAVIGATION.NEXT_TOOLTIP_DISABLED' | translate)
                "
                (click)="onNext()"
              >
                {{ "WIZARD.NAVIGATION.NEXT" | translate }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
